import * as authActionConstants from '../../constants/actions/auth';

export function setCurrentTab(tab) {
    return dispatch => {
            dispatch({ type: authActionConstants.SET_ACCOUNT_CURRENT_TAB, payload: tab })
    };
}
